import React from 'react';
import { useTranslation } from 'react-i18next';

const EmptyList = ({ create, join }) => {
    const { t } = useTranslation();
    return (<div className={`clubListInit`} >
        <div className={"search"}>
            <button className="secondary" onClick={join}><span>{t('joinClub')}</span></button>
        </div>
        <div className={"join"}>
            <button className="primary" onClick={create}><span>{t('createClub')}</span></button>
        </div>
    </div>);
};

export default EmptyList;
